import React from 'react';
import { CAMPAIGNS_GROUP_STATUS as CampaignsGroupStatus } from 'modules/campaigns/config';
import { getCampaignsGroupStatusMessages } from 'modules/campaigns/services/utils';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import StatusCellRenderer from './StatusCellRenderer/StatusCellRenderer';

const RUNNING_STATUSES = ['CAMPAIGNS_RUNNING', 'SOME_CAMPAIGNS_RUNNING'];

const CampaignsGroupStatusRenderer = props => {
    const {
        value: { status, displayStatus },
    } = props;
    const enableEnhancedCampaignGroupStatus = useConfigMatch({
        [FEATURE_FLAGS.CAMPAIGN_GROUP_ENABLED]: 'true',
    });

    const resolvedStatus = status || displayStatus;
    const isRunning = resolvedStatus === CampaignsGroupStatus.RUNNING;
    const campaignsGroupStatusMessages = getCampaignsGroupStatusMessages(resolvedStatus);
    const campaignsDisplayStatuses = props?.data?.campaignsDisplayStatuses;
    const phase =
        enableEnhancedCampaignGroupStatus && isRunning && !RUNNING_STATUSES.includes(campaignsDisplayStatuses)
            ? campaignsDisplayStatuses
            : null;

    return <StatusCellRenderer {...props} {...campaignsGroupStatusMessages} value={resolvedStatus} phase={phase} />;
};

export default CampaignsGroupStatusRenderer;
